import React, { useState } from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import { GheAnalogueTablesTab } from '../../components/gheAnalogueTables/GheAnalogueTablesTab';
import ProjectShell from '../../components/layout/ProjectShell';
import { Button, HelpWindow, gheHelpTopics } from '../../design-system';

type IconProps = { size?: number; color?: string; style?: React.CSSProperties };
const HelpIcon = FiHelpCircle as React.FC<IconProps>;

const AnalogueTablesPage = () => {
  const [helpOpen, setHelpOpen] = useState(false);
  const helpButton = (
    <Button variant="secondary" startIcon={<HelpIcon size={14} />} onClick={() => setHelpOpen(true)}>
      Help
    </Button>
  );
  return (
    <ProjectShell>
      <GheAnalogueTablesTab actions={helpButton} />
      <HelpWindow topics={gheHelpTopics} open={helpOpen} onClose={() => setHelpOpen(false)} />
    </ProjectShell>
  );
};

export default AnalogueTablesPage;
